<template>
  <b-container fluid class="h-100 px-0" style="min-height: 100vh">
    <div
      :class="['content-login', 'h-100', fontClass]"
      style="min-height: 100vh"
    >
      <b-row
        cols-lg="3"
        cols-md="2"
        cols-sm="2"
        class="justify-content-center h-100 mx-0"
      >
        <b-col align-self="center">
          <b-card class="card-login">
            <b-dropdown
              class="language-dropdown mt-4"
              toggle-class="language-toggle"
              variant="light"
              right
              no-caret
            >
              <template #button-content>
                <b-icon icon="globe" aria-hidden="true" />
                <span class="sr-only">{{ copy.language }}</span>
              </template>

              <b-dropdown-item
                v-for="option in languageOptions"
                :key="option.value"
                :active="language === option.value"
                @click="language = option.value"
              >
                {{ option.text }}
              </b-dropdown-item>
            </b-dropdown>

            <b-img
              class="logo logo-float"
              alt="Vue logo"
              :src="logoSrc"
            ></b-img>

            <h4 class="txt-white mt-4">{{ copy.greeting }}</h4>
            <span class="txt-white">{{ copy.instruction }}</span>
            <b-form @submit.prevent="handleSubmit" class="max-35 px-1 mb-4">
              <b-form-input
                id="form-input-name"
                @focus="hideAlert()"
                class="my-3 max-35 text-center rounded-pill form-control-lg"
                :placeholder="copy.placeholder"
                type="tel"
                inputmode="numeric"
                v-model="msisdn"
                required
              ></b-form-input>
              <b-button
                type="submit"
                block
                variant="success"
                class="max-35 rounded-pill btn-lg"
                >{{ copy.login }}</b-button
              >
            </b-form>

            <b-tooltip
              ref="tooltip"
              target="form-input-name"
              :disabled.sync="disabled"
            >
              <div class="tooltip-custom">{{ copy.unsupported }}</div>
            </b-tooltip>

            <div class="mt-3 text-center d-flex justify-content-center">
              <span v-if="copy.install" class="txt-white">
                {{ copy.install }}
                <a
                  @click.prevent="openInstallLink"
                  class="txt-white"
                  style="
                    cursor: pointer;
                    text-decoration: underline;
                    margin-left: 6px;
                  "
                >
                  {{ copy.esim }}
                </a>
              </span>
            </div>
          </b-card>
          <b-modal id="error-modal" title="Error" hide-footer>
            <div class="mb-3">
              <pre style="white-space: pre-wrap; word-break: break-word">{{
                errorMessage || "An unexpected error occurred."
              }}</pre>
            </div>
            <b-button
              variant="primary"
              block
              @click="$bvModal.hide('error-modal')"
              >Close</b-button
            >
          </b-modal>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<!-- SCRIPT LOGIC SECTION -->
<script>
import { mapActions, mapState } from "vuex";
import { apiMsg } from "@/provider/index.js";
export default {
  data() {
    return {
      disabled: true,
      language: "km",
      languageOptions: [
        { value: "en", text: "English" },
        // { value: "id", text: "Indonesia" },
        { value: "km", text: "កម្ពុជា" },
      ],
      translations: {
        en: {
          language: "Language",
          greeting: "",
          instruction: "Please enter your phone number",
          placeholder: "855xxxxx",
          login: "Login",
          unsupported: "This provider number is not supported.",
          install: "Need a cellcard phone number? ",
          link: "https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim",
          esim: "Get eSIM",
        },
        id: {
          language: "Bahasa",
          greeting: "Hai!",
          instruction: "Untuk mulai main, masukkan nomor handphonemu di sini:",
          placeholder: "628xxxxxxxxx",
          login: "Login",
          unsupported: "Tidak mendukung nomor provider ini.",
          install: "",
          link: "",
        },
        km: {
          language: "ភាសា",
          greeting: "",
          instruction: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក",
          placeholder: "855xxxxxxxx",
          login: "ចូលគណនី",
          unsupported: "លេខរបស់ប្រតិបត្តិករនេះមិនត្រូវបានគាំទ្រទេ។",
          install: "តម្រូវការស៊ីមសែលកាតមែនទេ? ",
          link: "https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim",
          esim: "ទិញ eSIM ឥឡូវនេះ",
        },
      },
      msisdn: null,
      token: null,
      form: {
        msisdn: null,
      },
      errorMessage: null,
      errorDetails: null,
      telcos: null,
      isLoading: false,
      a_table:
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
      b_table: null,
    };
  },
  mounted() {
    let savedLanguage = null;
    localStorage.setItem("loginLanguage", this.language);

    try {
      savedLanguage = localStorage.getItem("loginLanguage");
    } catch (e) {
      console.warn("localStorage unavailable", e);
    }

    if (savedLanguage && this.translations[savedLanguage])
      this.language = savedLanguage;
    document.documentElement.lang = this.language;
    if (this.android && window.androidOrientation)
      window.androidOrientation.postMessage("portrait");
    this.b_table = this.a_table.split(" ").map(function (s) {
      return parseInt(s, 16);
    });
    this.hideAlert();
  },
  computed: {
    ...mapState(["telco", "secretKey", "android"]),
    copy() {
      return this.translations[this.language];
    },
    logoSrc() {
      return require("@/assets/login-logo-kh.png");
    },
    fontClass() {
      if (this.language === "en") return "font-inter";
      if (this.language === "km") return "font-noto";
      return "";
    },
  },
  watch: {
    language(value) {
      try {
        localStorage.setItem("loginLanguage", value);
      } catch (e) {
        console.warn("localStorage unavailable", e);
      }
      document.documentElement.lang = value;
    },
  },
  methods: {
    ...mapActions(["getProfile", "getSubscriptionStatusByFakeId2"]),
    async handleSubmit() {
      const msisdnInput = String(this.msisdn || "").replace(/\D/g, "");
      if (msisdnInput.length >= 7) {
        // =================================
        // MSISDN INPUT VALIDATION
        // =================================
        // let msisdn = msisdnInput;
        // if (msisdn.charAt(0) === "0") {
        //   msisdn = "855" + msisdn.substring(1);
        // }

        let msisdn = String(msisdnInput).trim();

        if (msisdn.startsWith("0")) {
          msisdn = "855" + msisdn.substring(1);
        } else if (!msisdn.startsWith("855")) {
          msisdn = "855" + msisdn;
        }

        this.msisdn = msisdn;
        this.$store.state.isLoading = true;
        const _token = btoa(msisdn);

        // =================================
        // GET PROFILE
        // =================================
        this.$store.state.user = msisdn;
        this.token = _token;
        this.getProfile().then(
          () => {
            this.$store.state.isLoading = false;
            if (
              this.telco === "smart" ||
              this.telco === "tsel" ||
              this.telco === "cellcard"
            ) {
              this.$store.state.pid = this.b_crc32(msisdn);
              this.setStore();

              // WE CHECK SUBSCRIPTION STATUS HERE
              this.getSubscriptionStatusByFakeId2()
                .then((dataUser) => {
                  if (dataUser?.status != "1") {
                    this.$router.push({ name: "subscribe" });
                  } else if (dataUser?.status == "1") {
                    this.$router.push({ name: "otp" });
                  }
                })
                .catch((err) => {
                  this.$store.state.isLoading = false;
                  this.errorDetails = err;
                  this.errorMessage =
                    "Oops! A network error occurred. Please try again.";
                  this.$bvModal.show("error-modal");
                  this.sendErrorLog(err, "getSubscriptionStatusByFakeId2");
                });
            } else {
              this.showAlert();
            }
          },
          (error) => {
            console.error("err", error);
            this.$store.state.isLoading = false;
            this.errorDetails = error;
            this.errorMessage =
              "Oops! A network error occurred. Please try again.";
            this.$bvModal.show("error-modal");
            this.sendErrorLog(error, "getProfile");
          },
        );
        this.hideAlert();
      }
    },

    setStore() {
      this.$store.commit("SET_TOKEN", this.token);
      this.$store.commit("SET_USER", this.msisdn);
    },

    async sendErrorLog(error, context) {
      const safeStringify = (obj) => {
        try {
          return JSON.stringify(obj, Object.getOwnPropertyNames(obj));
        } catch (e) {
          try {
            return String(obj);
          } catch (e2) {
            return "unserializable error";
          }
        }
      };

      const message =
        error && error.message ? error.message : safeStringify(error);
      const stack =
        error && error.stack
          ? error.stack
          : error && error.response
          ? safeStringify(error.response)
          : safeStringify(error);

      const payload = {
        level: "error",
        message: message,
        url:
          window.location.href || (this.$route && this.$route.fullPath) || null,
        stack: stack,
        extra: {
          msisdn: this.msisdn || this.$store.state.user || null,
          context: context || null,
          onLine:
            typeof navigator !== "undefined" ? navigator.onLine : undefined,
          userAgent:
            typeof navigator !== "undefined" ? navigator.userAgent : undefined,
          clientDiagnostics: error && error.clientDiagnostics,
          axiosCode: error && error.code,
          hasResponse: !!(error && error.response),
          requestUrl:
            error && error.config
              ? (error.config.baseURL || "") + (error.config.url || "")
              : undefined,
        },
      };

      try {
        await apiMsg.post("a/fe", payload);
      } catch (e) {
        // if logging fails, still surface in console for debugging
        console.warn("failed to send error log to apiMsg", e, payload);
      }
    },

    formatError(error) {
      try {
        const parts = [];
        if (!error) return "No error information";
        if (error.message) parts.push(`message: ${error.message}`);
        if (error.code) parts.push(`code: ${error.code}`);
        if (error.stack) parts.push(`stack: ${error.stack}`);
        if (error.config && error.config.url)
          parts.push(
            `request: ${error.config.method || "GET"} ${error.config.url}`,
          );
        if (error.response) {
          try {
            parts.push(`response.status: ${error.response.status}`);
            parts.push(`response.data: ${JSON.stringify(error.response.data)}`);
          } catch (e) {
            parts.push(`response: [unserializable]`);
          }
        }
        // axios specific
        if (error.isAxiosError && error.toJSON) {
          try {
            parts.push(`axios: ${JSON.stringify(error.toJSON())}`);
          } catch (e) {
            console.log(e);
          }
        }
        if (parts.length === 0) return String(error);
        return parts.join("\n");
      } catch (e) {
        return String(error);
      }
    },

    showAlert() {
      this.disabled = false;
      this.$refs.tooltip.$emit("open");
    },
    hideAlert() {
      this.disabled = true;
      this.$refs.tooltip.$emit("close");
    },
    openInstallLink() {
      const link = this.copy && this.copy.link;
      if (!link) return;
      try {
        window.open(link, "_blank", "noopener");
      } catch (e) {
        window.location.href = link;
      }
    },
    b_crc32(str) {
      var crc = -1;
      for (var i = 0, iTop = str.length; i < iTop; i++) {
        crc = (crc >>> 8) ^ this.b_table[(crc ^ str.charCodeAt(i)) & 0xff];
      }
      return (crc ^ -1) >>> 0;
    },
  },
};
</script>

<!-- STYLE SECTION -->
.style-font-imports { }
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&family=Noto+Sans+Khmer:wght@400;700&display=swap");

.content-login {
  min-height: 100vh;

  background-color: #0b40a2;

  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.75) 0%,
      rgba(0, 0, 0, 0.45) 25%,
      rgba(0, 0, 0, 0.15) 50%,
      rgba(0, 0, 0, 0) 75%
    ),
    url("../assets/login-logo-mobile.png");

  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.card-login {
  background-color: transparent;
  border: none;
  position: relative;
}
.language-dropdown {
  position: absolute;
  right: 23px;
  top: 10px;
  z-index: 2;
}
.language-dropdown::v-deep .language-toggle {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  padding: 0;
  width: 42px;
}
.logo {
  height: 30vh;
  max-height: 320px;
  margin-top: 120px;
}

.logo-float {
  animation: logoEntrance 1.2s ease-out both;
  transform-origin: center;
  filter: drop-shadow(0 14px 24px rgba(0, 0, 0, 0.28));
}

@keyframes logoEntrance {
  0% {
    opacity: 0;
    transform: translateY(20px) rotate(-10deg) scale(0.92);
  }
  60% {
    opacity: 1;
    transform: translateY(-4px) rotate(6deg) scale(1.04);
  }
  100% {
    opacity: 1;
    transform: translateY(0) rotate(0deg) scale(1);
  }
}

.txt-white {
  color: white;
}
.tooltip-custom {
  /* color: red !important; */
  font-size: 0.8rem !important;
  max-width: 300px !important;
  padding: 0.5rem !important;
}

.font-inter {
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.font-noto {
  font-family: "Noto Sans Khmer", "Noto Sans", sans-serif;
}
</style>
